export const tabOptions = {
  information: 'Information',
  agenda: 'Agenda',
  participants: 'Participants',
  billing: 'Billing',
  consents: 'Consents',
  attachments: 'Attachments',
  notes: 'Notes',
  sessions: 'Sessions',
  speakers: 'Speakers',
  hotels: 'Hotels',
  messages: 'Messages',
  overview: 'Overview'
};

export const ParticipantStatus = {
  ToBeInvited: 1,
  ApprovalNeeded: 2,
  Reserved: 3,
  ApprovalDeclined: 4,
  Cancelled: 5,
  RegistrationConfirmed: 6,
  Invited: 7,
  WaitingCancelled: 8
};

export const ConditionTypes = {
  STANDARD_PRICE: 1,
  MANUAL_DISCOUNT: 2,
  AUTOMATIC_DISCOUNT: 3,
  CANCELLATION_DISCOUNT: 4
};

export const EVENT_TYPES = {
  TRAINING: 'TRAINING',
  WEBINAR: 'WEBINAR',
  HYBRID: 'HYBRID'
};

export const DiscountTypes = {
  PERCENTAGE: 'PERCENTAGE',
  FIXED_PRICE: 'FIXED_PRICE'
};
